// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1j1Wh","title":"styles_title__QcZpC"};